/**
 * 全局鼠标 loading 工具
 *
 * 通过向 <head> 注入 `* { cursor: progress !important }` 样式，将全局鼠标光标置为
 * 系统原生 loading 态。!important 可覆盖按钮等元素自身的 cursor 样式（如 tea 的
 * pointer），保证 loading 期间鼠标无论悬停在何处都显示 loading 光标，结束后移除
 * 样式恢复原状。
 *
 * 内部使用引用计数：多个流程并发开启时，需全部结束才移除。
 */

let cursorLoadingCount = 0;
let cursorLoadingStyleEl: HTMLStyleElement | null = null;

export function setCursorLoading(loading: boolean) {
  if (loading) {
    cursorLoadingCount += 1;
    if (!cursorLoadingStyleEl) {
      cursorLoadingStyleEl = document.createElement('style');
      cursorLoadingStyleEl.id = 'global-cursor-loading';
      cursorLoadingStyleEl.textContent = '* { cursor: progress !important; }';
      document.head.appendChild(cursorLoadingStyleEl);
    }
    return;
  }

  cursorLoadingCount = Math.max(0, cursorLoadingCount - 1);
  if (cursorLoadingCount === 0 && cursorLoadingStyleEl) {
    cursorLoadingStyleEl.remove();
    cursorLoadingStyleEl = null;
  }
}
